import { formatDateShort } from '~/lib/DateTime';
import { StatusBadge } from '~/components/packages/GrantList';
import { humanGrantRedeemableAmount } from '~/lib/PackageHelpers';
import React from 'react';

const SingleSubscription = ({ grant, isFirst }) => {
    const renews = grant?.next_renewal_at
        ? formatDateShort(grant?.next_renewal_at)
        : '';

    return (
        <div
            className={`${!isFirst ? 'border-t' : ''} py-3 pr-4 flex items-center justify-between `}
        >
            <div className="flex-1">
                {grant?.package?.name || 'Unknown Package'}
            </div>
            <div className="flex-1">
                <StatusBadge grant={grant} />
            </div>
            <div className="flex-1">
                {humanGrantRedeemableAmount(grant)}
                <div className="text-sm sm:hidden">{renews}</div>
            </div>
            <div className="flex-1 hidden sm:block">{renews}</div>
            <div className="flex-1">
                <a
                    href={grant?.form_submission?.confirmation_url}
                    target="_blank"
                    className="form-button btn-small !no-underline"
                >
                    Manage
                </a>
            </div>
        </div>
    );
};

const SubscriptionHistory = ({ packages }) => {
    return (
        <div>
            {packages.length > 0 && (
                <div className="flex items-center justify-between mx-6">
                    <div className="flex-1 column-label">Name</div>
                    <div className="flex-1 column-label">Status</div>
                    <div className="flex-1 column-label">Remaining</div>
                    <div className="flex-1 column-label hidden sm:block">
                        Renews
                    </div>
                    <div className="flex-1 column-label">&nbsp;</div>
                </div>
            )}

            <div className="panel pl-4">
                {packages.length === 0 && (
                    <div className="py-3">You have no subscriptions</div>
                )}
                {packages.map((grant, idx) => (
                    <SingleSubscription grant={grant} isFirst={idx === 0} />
                ))}
            </div>
            <div className="mt-2 text-gray-500 mx-4">
                Your Default card will be charged for subscription renewals. You
                can change this within Billing.
            </div>
        </div>
    );
};

export default SubscriptionHistory;
